import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#495964" }) => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3701_6290)">
        <path
          d="M18.4995 30.0624C19.4573 30.0624 20.2338 29.2859 20.2338 28.3281C20.2338 27.3702 19.4573 26.5938 18.4995 26.5938C17.5416 26.5938 16.7651 27.3702 16.7651 28.3281C16.7651 29.2859 17.5416 30.0624 18.4995 30.0624Z"
          fill="#CC1C1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.5 0C8.28274 0 0 8.28274 0 18.5C0 28.7173 8.28274 37 18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28274 28.7173 0 18.5 0ZM18.5 35.8438C8.93666 35.8438 1.15625 28.0634 1.15625 18.5C1.15625 8.93666 8.93666 1.15625 18.5 1.15625C28.0634 1.15625 35.8438 8.93666 35.8438 18.5C35.8438 28.0634 28.0634 35.8438 18.5 35.8438Z"
          fill="#CC1C1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9906 24.2812H19.0094C19.3201 24.2812 19.5752 24.0358 19.5872 23.7254L20.2112 7.53788C20.2239 7.21014 19.9615 6.9375 19.6335 6.9375H17.3665C17.0385 6.9375 16.7761 7.21014 16.7888 7.53788L17.4129 23.7254C17.4249 24.0358 17.68 24.2812 17.9906 24.2812Z"
          fill="#CC1C1C"
        />
      </g>
      <defs>
        <clipPath id="clip0_3701_6290">
          <rect width="37" height="37" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default memo(Icon);
